import {
  aprovarRelatorioHomologacao,
  getAnexoRelatorioHomologacao,
  getRelatorioHomologacao,
  getTemplateRelatorioHomologacao,
  onRelatorioHomologacao,
  RelatorioHomologacaoProps,
} from '@app/api/sas/relatorioHomologacao';
import { UploadMultProps, Visibility } from '@app/components';
import { Button, FormatText, FormSubmitButton, MasterDetailForm, Widget } from '@digital/ui';
import { Collapse, Icon } from 'antd';
import React, { useEffect, useState } from 'react';
import FormAbaRelHomologacao from './FormAbaRelHomologacao';
import {
  desabilitarAcoesState,
  ordemCompraAbasState,
  ordemCompraIdState,
  reloadAbaStateState,
  reloadState,
} from '../atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import ModalReprovarRelatorioHomologacao from './ModalReprovarRelatorioHomologacao';
import { hasPermission } from '@app/helpers/permissions';
import ModalReenviarAprovacaoRelatorioHomologacao from './ModalReenviarAprovacaoRelatorioHomologacao';
import ModalHistorioAprovacoes from './ModalHistorioAprovacoes';
const { Panel } = Collapse;

interface Props {
  parteDoFluxo?: boolean;
  ehComprador: boolean;
}

const WidgetRelatorioHomologacao = ({ parteDoFluxo = false, ehComprador }: Props) => {
  const ordemCompraId = useRecoilValue(ordemCompraIdState);
  const desabilitarAcoes = useRecoilValue(desabilitarAcoesState);
  const [reload, setReload] = useRecoilState(reloadState);
  const [reloadAba, setReloadAba] = useRecoilState(reloadAbaStateState);

  const [dadosRelatorio, setDadosRelatorio] = useState<RelatorioHomologacaoProps>();
  const [nomeArquivo, setNomeArquivo] = useState<string | undefined>(undefined);
  const [idArquivo, setIdArquivo] = useState<string | undefined>(undefined);
  const [data, setData] = useState<any[]>([]);
  const [reloadRelatorio, setReloadRelatorio] = useState<boolean>(false);
  const [url, setURL] = useState(window.location.href);

  const onReloadRelatorio = () => {
    setReloadRelatorio(!reloadRelatorio);
    setReloadAba(!reloadAba);
  };

  if (window.location.href != url) {
    setURL(window.location.href);
    if (window.location.href.toLocaleLowerCase().includes('relhomologacao')) onReloadRelatorio();
    if (window.location.href.toLocaleLowerCase().includes('fluxoprocesso')) onReloadRelatorio();
  }

  const getInfoRelatorio = (ocId: string) => {
    getRelatorioHomologacao(ocId).then(data => {
      if (data) {
        setDadosRelatorio(data);
        if (data.anexoNome) {
          setIdArquivo(data.anexoId);
          setNomeArquivo(data.anexoNome);
        }
      }
    });
  };

  useEffect(() => {
    if (ordemCompraId) {
      getInfoRelatorio(ordemCompraId);
    }
  }, [ordemCompraId, reload, reloadRelatorio]);

  const exportFile = async () => {
    await getTemplateRelatorioHomologacao(ordemCompraId);
  };

  const downloadFile = async () => {
    await getAnexoRelatorioHomologacao(idArquivo!, nomeArquivo!);
  };

  const fileUpload = (e: any) => {
    setNomeArquivo(e.file.fileName);
    setIdArquivo(e.id);
  };

  const updateValues = async (values: any) => {
    if (data.length > 0) {
      values.valorAditivo = data[data.length - 1].valorAditivo;
      values.terminoVigenciaAditivo = data[data.length - 1].terminoVigencia;
    }
    if (!dadosRelatorio) {
      return;
    }
    await onRelatorioHomologacao(ordemCompraId, {
      ...values,
      condicoesComerciais: dadosRelatorio.tipoOc === 2 ? data : [],
    });

    onReloadRelatorio();
  };

  const handleAprovarRelatorio = () => {
    aprovarRelatorioHomologacao(ordemCompraId, '').then(data => {
      if (data && data.valid) {
        onReloadRelatorio();
      }
    });
  };
  const podeSalvarBase = !parteDoFluxo && ehComprador && desabilitarAcoes === false;

  const isFaturamentoDireto = dadosRelatorio && dadosRelatorio.tipoOc === ETipoDemanda.FaturamentoDireto;

  const isHomologadoSuccess =
    dadosRelatorio &&
    dadosRelatorio.aprovacaoGerenteAquisicoesStatus === 'Aprovado' &&
    dadosRelatorio.aprovacaoGerenteGeralStatus === 'Aprovado';

  const deveExibirSalvar = podeSalvarBase && (isFaturamentoDireto ? !isHomologadoSuccess : true);
  return (
    <>
      {dadosRelatorio && (
        <Collapse
          bordered={false}
          defaultActiveKey="AbaRelatorioHomologacao"
          expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel
            key="AbaRelatorioHomologacao"
            header={`Relatório de Homologação - ${
              dadosRelatorio && (dadosRelatorio.tipoOc === ETipoDemanda.NovaContratacao
                ? 'Nova Contratação'
                : dadosRelatorio.tipoOc === ETipoDemanda.FaturamentoDireto
                ? 'Faturamento Direto'
                : 'Aditivo') || 'Carregando...'
            }`}
            showArrow={!parteDoFluxo}>
            <Widget className="aba-rel-homologacao">
              <MasterDetailForm
                actions={[
                  <Visibility
                    visible={
                      ['Pendente', 'Em Revisão'].includes(dadosRelatorio.aprovacaoGerenteAquisicoesStatus) &&
                      hasPermission(['SAS_APROVAR_RELATORIO_HOMOLOGACAO_GERENTE_AQUISICAO']) &&
                      !parteDoFluxo
                    }>
                    <Button
                      style={{ marginRight: 10 }}
                      onClick={handleAprovarRelatorio}
                      title="Aprovar"
                      type="primary"
                    />
                  </Visibility>,

                  <Visibility
                    visible={
                      !['Pendente', 'Em Revisão'].includes(dadosRelatorio.aprovacaoGerenteAquisicoesStatus) &&
                      ['Pendente', 'Em Revisão'].includes(dadosRelatorio.aprovacaoGerenteGeralStatus) &&
                      hasPermission(['SAS_APROVAR_RELATORIO_HOMOLOGACAO_GERENTE_GERAL']) &&
                      !parteDoFluxo
                    }>
                    <Button
                      style={{ marginRight: 10 }}
                      onClick={handleAprovarRelatorio}
                      title="Aprovar"
                      type="primary"
                    />
                  </Visibility>,

                  <Visibility
                    visible={
                      ['Pendente', 'Em Revisão'].includes(dadosRelatorio.aprovacaoGerenteAquisicoesStatus) &&
                      ['Em Revisão'].includes(dadosRelatorio.aprovacaoGerenteGeralStatus) &&
                      hasPermission(['SAS_APROVAR_RELATORIO_HOMOLOGACAO_GERENTE_AQUISICAO']) &&
                      !parteDoFluxo
                    }>
                    <ModalReenviarAprovacaoRelatorioHomologacao onReloadRelatorio={onReloadRelatorio} />
                  </Visibility>,

                  <Visibility
                    visible={
                      (['Em Revisão', 'Pendente'].includes(dadosRelatorio.aprovacaoGerenteGeralStatus) &&
                        hasPermission(['SAS_APROVAR_RELATORIO_HOMOLOGACAO_GERENTE_GERAL'])) ||
                      (['Em Revisão', 'Pendente'].includes(dadosRelatorio.aprovacaoGerenteAquisicoesStatus) &&
                        hasPermission(['SAS_APROVAR_RELATORIO_HOMOLOGACAO_GERENTE_AQUISICAO']) &&
                        !parteDoFluxo)
                    }>
                    <ModalReprovarRelatorioHomologacao onReloadRelatorio={onReloadRelatorio} />
                  </Visibility>,

                  <Visibility visible={parteDoFluxo}>
                    <ModalHistorioAprovacoes />
                  </Visibility>,

                  <>
                    {idArquivo && !parteDoFluxo && (
                      <Button style={{ marginRight: 10 }} type="primary" onClick={downloadFile}>
                        <FormatText id="DOWNLOAD" />
                      </Button>
                    )}
                  </>,
                  <UploadMultProps
                    visible={!parteDoFluxo && ehComprador && desabilitarAcoes === false}
                    idDoComponente="mrn-button-AbaRelHomologacao-upload-incluir"
                    tooltip={'Incluir Arquivo'}
                    listUploadPropsForm={
                      idArquivo
                        ? [
                            { key: 'ordemCompraId', value: ordemCompraId },
                            { key: 'id', value: idArquivo },
                          ]
                        : [{ key: 'ordemCompraId', value: ordemCompraId }]
                    }
                    enderecoApi={`rhSas/anexo`}
                    iconName={'ui-upload'}
                    hasFile={false}
                    label={idArquivo ? 'ATUALIZAR ANEXO' : 'INCLUIR ANEXO'}
                    buttonClass="ant-btn-primary"
                    retorno={e => fileUpload(e)}
                  />,
                  <Visibility visible={!parteDoFluxo && ehComprador}>
                    <Button style={{ marginLeft: 10 }} type="primary" onClick={exportFile}>
                      <FormatText id="EXPORTAR" />
                    </Button>
                  </Visibility>,
                  <>
                    {deveExibirSalvar && (
                      <FormSubmitButton
                        style={{ marginLeft: 10 }}
                        type="primary"
                        noIcon
                        onClick={item => updateValues(item)}>
                        <FormatText id="SALVAR" />
                      </FormSubmitButton>
                    )}
                  </>,
                ]}>
                {dadosRelatorio &&
                (dadosRelatorio.nomePropostaPremiada || dadosRelatorio.tipoOc == ETipoDemanda.Aditivo) ? (
                  <FormAbaRelHomologacao
                    dadosRelatorio={dadosRelatorio}
                    setNewDate={setData}
                    parteDoFluxo={parteDoFluxo}
                    ehComprador={ehComprador}
                  />
                ) : (
                  'O vencedor ainda não foi definido na Aba Dados Gerais'
                )}
              </MasterDetailForm>
            </Widget>
          </Panel>
        </Collapse>
      )}
    </>
  );
};
export default WidgetRelatorioHomologacao;
